import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import DatePickerAdapter from '../../../DatePickerAdapter.jsx';
import TaskStatusField from './CreateEditTaskFormFields/TaskStatusField.jsx';
import EmployeesFormField from '../../../employees-form-field/EmployeesFormField.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';

import Editor from '../../../editor/editor.jsx';

function TaskForm(props) {
  const {
    handleSubmit,
    selectedOwners,
    onSelectOwner,
    setEditorInstance,
    additionalSearchParams,
    onShowEmployeeModal,
    onCancel,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={8}>
          <Field
            id="title"
            name="title"
            label="Task Title"
            placeholder="Enter Title"
            type="text"
            component={FieldGroup}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={8} className="m-b-24">
          <Field
            id="owner"
            name="owner"
            selected={selectedOwners}
            handleSelect={onSelectOwner}
            additionalSearchParams={additionalSearchParams}
            title="Task Owner(s)"
            isItemActive={(val) => selectedOwners.some(({ id }) => id === val)}
            component={EmployeesFormField}
            addBtn={
              <AuthorizedAction action="create" subject="employee">
                <button
                  type="button"
                  className="btn-link"
                  onClick={onShowEmployeeModal}
                >
                  {' '}
                  + Add New Employee
                </button>
              </AuthorizedAction>
            }
          />
        </Col>
      </Row>

      <Row>
        <Col xs={8}>
          <Row>
            <Col xs={6}>
              <Field
                id="startDate"
                name="startDate"
                label="Start Date"
                placeholderText="Select a Date"
                component={DatePickerAdapter}
                allowNull
                defaultValue={null}
              />
            </Col>
            <Col xs={6}>
              <Field
                id="endDate"
                name="endDate"
                label="End Date"
                placeholderText="Select a Date"
                component={DatePickerAdapter}
                allowNull
                defaultValue={null}
              />
            </Col>
          </Row>
        </Col>

        <Col xs={5}>
          <TaskStatusField label="Task Status" name="status" />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <div className="m-b-24">
            <Field name="description">
              {({ name, input }) => {
                const taskDescription = input.value
                  ? JSON.parse(input.value)
                  : null;

                return (
                  <Editor
                    name={name}
                    data={taskDescription}
                    label="Task Description"
                    setEditorInstanceForParent={setEditorInstance}
                    options={{
                      holder: 'create-edit-task-modal-editor',
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Button className="btn btn-default" onClick={onCancel}>
            Cancel
          </Button>
          <Button bsStyle="primary" type="submit" className="m-l-12">
            Save
          </Button>
        </Col>
      </Row>
    </form>
  );
}

export default TaskForm;
